// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

// Highlighting for code blocks
import "prismjs/themes/prism.css"
import "./styles/variables.css"
import "./styles/index.css"
import "./styles/blog-layout.css"
import "./styles/table-of-contents.css"
import "./styles/ux-enhancements.css"
import "./styles/page-common.css"

import React from "react"
import { ThemeProvider } from "./src/contexts/ThemeContext"

export const wrapRootElement = ({ element }) => {
  return <ThemeProvider>{element}</ThemeProvider>
}

export const shouldUpdateScroll = () => {
  return false
}

export const onRouteUpdate = () => {
  if (typeof window !== 'undefined') {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })

    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    })

    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
    }, 50)
  }
}
